import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './text.styl'

export default class Text extends Component {
  static propTypes = {
    children: PropTypes.any,
    maxWidth: PropTypes.any
  }

  static defaultProps = {
    maxWidth: '100%'
  }

  render() {
    const { maxWidth, children } = this.props

    return (
      <span className={styles.text} style={{ maxWidth }}>
        {children}
      </span>
    )
  }
}
